import React, { useEffect, useRef } from "react";
import { Link } from "react-scroll";
import { IoMdClose } from "react-icons/io";
import { logoLight } from "../../assets/images";

const Header = () => {
  const menuBarRef = useRef(null);
  const menuOpenBtnRef = useRef(null);

  useEffect(() => {
    const menuBar = menuBarRef.current;
    const menuOpenBtn = menuOpenBtnRef.current;
    const menuCloseBtn = document.querySelector(".menuCloseBtn");

    const openMenu = () => {
      menuBar.style.transform = "translateX(0)";
      menuBar.style.opacity = "1";
      menuBar.style.transition = "ease-in-out 0.5s";
    };

    const closeMenu = () => {
      menuBar.style.transform = "translateX(-100%)";
      menuBar.style.opacity = "0";
      menuBar.style.transition = "ease-in-out 0.5s";
    };

    const handleOutsideClick = (e) => {
      if (
        menuBarRef.current &&
        !menuBarRef.current.contains(e.target) &&
        !menuOpenBtnRef.current.contains(e.target)
      ) {
        closeMenu();
      }
    };

    menuOpenBtn.addEventListener("click", openMenu);
    menuCloseBtn.addEventListener("click", closeMenu);

    // Add click event listener for outside clicks
    document.addEventListener("click", handleOutsideClick);

    // Handle menu item clicks
    const menuLinks = document.querySelectorAll(
      ".homeLinkBtn, .aboutLinkBtn, .docsLinkBtn",
    );
    menuLinks.forEach((link) => link.addEventListener("click", closeMenu));

    // Cleanup event listeners
    return () => {
      menuOpenBtn.removeEventListener("click", openMenu);
      menuCloseBtn.removeEventListener("click", closeMenu);
      document.removeEventListener("click", handleOutsideClick);
      menuLinks.forEach((link) => link.removeEventListener("click", closeMenu));
    };
  }, []);

  const navLinks = [
    { title: "Home", link: "/", type: "scroll" },
    { title: "About", link: "about", type: "scroll" },
    { title: "Docs", link: "docs", type: "scroll" },
    { title: "Tools", link: "https://www.reactbd.com/tools", type: "external" },
    { title: "Blog", link: "https://blog.reactbd.com/en", type: "external" },
    {
      title: "Hire Me",
      link: "https://noormohammad.reactbd.com/en",
      type: "external",
    },
  ];

  const renderNavLinks = (isMobile = false) => {
    return navLinks.map((item) => (
      <React.Fragment key={item.title}>
        {item.type === "scroll" ? (
          <li className="text-primeColor tracking-wider hover:text-designColor duration-300 cursor-pointer">
            <Link
              to={item.link}
              smooth={true}
              offset={-80}
              duration={500}
              className={`${item.title.toLowerCase()}LinkBtn`}
            >
              {item.title}
            </Link>
          </li>
        ) : (
          <a href={item.link} target="_blank" rel="noreferrer">
            <li className="text-primeColor tracking-wider hover:text-designColor duration-300 cursor-pointer">
              {item.title}
            </li>
          </a>
        )}
      </React.Fragment>
    ));
  };

  return (
    <div className="w-full h-20 border sticky top-0 z-50 bg-white">
      <div className="max-w-screen-xl mx-auto h-full flex justify-between items-center px-4">
        <div className="flex items-center gap-4">
          <div
            ref={menuOpenBtnRef}
            className="flex mdl:hidden flex-col gap-[5px] cursor-pointer group menuOpenBtn"
          >
            <span className="w-8 h-1 bg-gray-500 rounded-lg group-hover:bg-designColor duration-300 inline-block"></span>
            <span className="w-6 h-1 bg-gray-500 rounded-lg group-hover:bg-designColor duration-300 inline-block"></span>
            <span className="w-8 h-1 bg-gray-500 rounded-lg group-hover:bg-designColor duration-300 inline-block"></span>
          </div>
          <div>
            <img className="md:w-60 min-w-32" src={logoLight} alt="logoLight" />
          </div>
        </div>

        <div className="w-full">
          <ul className="hidden text-sm uppercase font-bold gap-12 mdl:flex justify-end">
            {renderNavLinks()}
          </ul>
        </div>
      </div>
      <div>
        <div
          ref={menuBarRef}
          className="absolute top-0 -left-1 w-[80%] mdl:hidden bg-white h-screen -translate-x-[100%] opacity-0 menuBar border-r border-r-designColor"
        >
          <div className="w-full h-full relative">
            <div className="p-10 flex flex-col gap-8">
              <img className="w-52 -ml-2" src={logoLight} alt="logoLight" />
              <ul className="text-sm uppercase font-bold gap-5 flex flex-col">
                {renderNavLinks(true)}
              </ul>
            </div>
            <div className="absolute top-4 right-4 text-2xl text-gray-500 hover:text-designColor duration-300 cursor-pointer menuCloseBtn">
              <IoMdClose />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
